import { useCallback } from 'react';
import { Card, MenuItem, Stack, Typography } from '@mui/material';
import { userModel } from 'entities/user';
import { Chains, FontWeights, Icon, isBuy, useShallowSelector, WalletProviders } from 'shared';
import { useWalletConnectorContext } from 'shared/config/wallet-connect';

import { ChainSelector } from './ui';

const PAGE_TITLE = isBuy ? 'Buy Mogul Token' : 'Stars exchange';

export const ConnectPage = () => {
  const { network } = useShallowSelector(userModel.selectors.selectUserWeb3Info);
  const { connect } = useWalletConnectorContext();

  const handleConnectWallet = useCallback(
    async (provider: WalletProviders, chain: Chains) => {
      await connect(provider, chain);
    },
    [connect],
  );

  return (
    <Stack spacing={{ xs: '36px', md: '54px' }} alignItems="center">
      <Typography variant="h1" sx={{ fontWeight: FontWeights.Light }}>
        {PAGE_TITLE}
      </Typography>
      <Card sx={{ maxWidth: 482, width: '100%' }}>
        <Stack spacing={2}>
          <Typography variant="h3">Connect Wallet</Typography>
          <ChainSelector />
          <Stack>
            <MenuItem onClick={() => handleConnectWallet(WalletProviders.metamask, network)}>
              <Icon type="metamask" size={42} />
              <Typography variant="button" sx={{ ml: '10px', fontSize: 20 }}>
                MetaMask
              </Typography>
            </MenuItem>
            <MenuItem onClick={() => handleConnectWallet(WalletProviders.walletConnect, network)}>
              <Icon type="walletconnect" size={42} />
              <Typography variant="button" sx={{ ml: '10px', fontSize: 20 }}>
                Wallet connect
              </Typography>
            </MenuItem>
          </Stack>
        </Stack>
      </Card>
    </Stack>
  );
};
